import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide.min.css';

const pbdsCarouselGridBanners = {
    init: function () {
        console.log("pbds-carousel--grid-banners: INIT");
        // Toggle Submenus 
        $('.pbds-carousel--grid-banners').each(
            function() {
                var jsCarouselGridContent = new Splide($(this).find('.jsCarouselGridContent')[0], {
                    type: 'fade',
                    rewind: true,
                    perPage: 1,
                    perMove: 1,
                    arrows: false,
                    pagination: false,
                    autoplay: false,
                    interval: 5000,
                    infinite: true,
                    breakpoints: {
                        769: {
                            pagination: true
                        }
                    }
                });
                if ($(this).find('.jsCarouselGridNav').length > 0)
                {
                    var jsCarouselGridNav = new Splide($(this).find('.jsCarouselGridNav')[0], {
                        arrows: false,
                        pagination: false,
                        isNavigation: true,
                        autoWidth: true
                    });
                    jsCarouselGridNav.sync(jsCarouselGridContent);
                }
                jsCarouselGridContent.mount();
                if ($(this).find('.jsCarouselGridNav').length > 0)
                {
                    jsCarouselGridNav.mount();
                }
            }
        );
    }
}

window.loadedComponents.push({ component: 'pbds-carousel--grid-banners', init: pbdsCarouselGridBanners.init});

export default() => {
    pbdsCarouselGridBanners.init();
}